import clsx from 'clsx'
import { h, Fragment } from 'preact'

export function Price({ price, compareAtPrice, className = 'flex' }) {
  const isOnSale = parseFloat(price) < parseFloat(compareAtPrice || 0)

  return (
    <p className={clsx('flex gap-1', className)}>
      <span className="paragraph-sm font-bold text-primary-sale only:text-primary-black">${price}</span>
      {!isOnSale ? null : (
        <span className="paragraph-sm text-neutrals-tertiary-grey line-through decoration-neutrals-tertiary-grey">
          ${compareAtPrice}
        </span>
      )}
    </p>
  )
}
